<template>
  <div class="flex justify-between">
    <div class="flex">
      <img
        :alt="`${name} image`"
        class="w-12 h-12 rounded-full"
        :src="imageUrl"
      >
      <p class="ml-3 font-light">{{ quantity }}x{{ name }}</p>
    </div>
    <p class="font-light">{{ currency }}{{ cost }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  currency: {
    required: true,
    type: String,
  },
  price: {
    required: true,
    type: Number,
  },
  name: {
    required: true,
    type: String,
  },
  imageUrl: {
    required: true,
    type: String,
  },
  quantity: {
    type: Number,
    required: true,
  },
});
const cost = computed(() => new Intl.NumberFormat().format(props.price * props.quantity));

</script>
